<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'yichangAuditList',
})
</script>
<template>
    <a-card :bordered="false">
        <!-- 搜索区 -->
        <div class="table-page-search-wrapper">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="6" :sm="24">
                        <a-form-item label="主体名称">
                            <a-input v-model:value="queryParam.nameOrCode" placeholder="请输入主体名称、税号" allow-clear
                                @keyup.enter="handleSearch" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="入驻地址">
                            <a-input v-model:value="queryParam.settle_address" placeholder="请输入入驻地址" allow-clear
                                @keyup.enter="handleSearch" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="审核状态">
                            <a-select v-model:value="queryParam.status" mode="multiple" allow-clear placeholder="请选择">
                                <a-select-option :value="1">待审核</a-select-option>
                                <a-select-option :value="2">已通过</a-select-option>
                                <a-select-option :value="3">已拒绝</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="审核类型">
                            <a-select v-model:value="queryParam.main_type" mode="multiple" allow-clear
                                placeholder="请选择">
                                <a-select-option :value="1">解除入驻合同</a-select-option>
                                <a-select-option :value="2">移出地址异常</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="录入系统时间">
                            <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                                :format="format" @change="rangTimeChange" style="width: 100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <span class="table-page-search-submitButtons">
                            <a-button type="primary" @click="handleSearch">查询</a-button>
                            <a-button style="margin-left: 8px" @click="refreshTable">重置</a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>

        <!-- 表格 -->
        <a-table :columns="columns" :loading="data.loading" :data-source="dataSource" :pagination="pagination"
            @change="onChange" size="middle">
            <template #bodyCell="{ column, record, text }">
                <!-- 公司名称 + 入驻地址 + 到期时间 -->
                <template v-if="column.dataIndex === 'name'">
                    <div>{{ record.full_name }}</div>
                    <div style="font-size:12px;color:#888;">📍 {{ record.full_address || record.registration_address ||
                        '--' }}</div>
                    <div style="font-size:12px;color:#888;">⏰ 入驻到期：{{ formatExpireTime(record.enter_endtime) }}
                    </div>
                    <a @click="goCustomerClick(record.full_name)">查看详情</a>
                </template>

                <!-- 审核 -->
                <template v-else-if="column.dataIndex === 'verification'">
                    <div v-if="record.status === 1">
                        <template v-if="record.audit_permission == 1">
                            <a-input v-model:value="record.desc" placeholder="选填理由" allow-clear
                                style="margin-bottom:8px" />
                            <div style="display:flex;gap:8px">
                                <a-popconfirm title="确定不通过?" @confirm="verificatioChange(record, 2)">
                                    <a-button danger style="flex:1">不通过</a-button>
                                </a-popconfirm>
                                <a-popconfirm title="确定通过?" @confirm="verificatioChange(record, 1)">
                                    <a-button type="primary" style="flex:1">通过</a-button>
                                </a-popconfirm>
                            </div>
                        </template>
                        <a-tag v-else color="processing">待审核</a-tag>
                    </div>
                    <div v-else>
                        <a-tag v-if="record.status === 2" color="success">审核通过</a-tag>
                        <a-tag v-else color="error">审核不通过</a-tag>
                        <div v-if="record.audit_remark" style="font-size:12px;color:#ff4d4f">
                            理由：{{ record.audit_remark }}
                        </div>
                    </div>
                </template>

                <!-- 审核类型 -->
                <template v-else-if="column.dataIndex === 'type'">
                    <span>{{ record.typeName }}</span>
                    <span v-if="record.type_son"> -{{ record.type_son }}</span>
                    <a-tag v-if="record.platform_stamp === 1" color="green">盖章</a-tag>
                    <a-tag v-if="record.platform_stamp === 2" color="red">不盖章</a-tag>
                </template>

                <!-- 代理商 -->
                <template v-else-if="column.dataIndex === 'seller'">
                    {{ record.seller || '--' }}
                </template>

                <!-- 申请审核人 -->
                <template v-else-if="column.dataIndex === 'submitName'">
                    {{ record.sellerName || '--' }}
                </template>

                <!-- 审核时间 -->
                <template v-else-if="column.dataIndex === 'updated_at'">
                    <template v-if="record.status !== 1">
                        <div>{{ record.operator_admin_info?.nickname || '--' }} {{ text }}审核完毕</div>
                        <div style="font-size:12px;color:#888">耗时 {{ calculateTimeDifference(record.created_at,
                            record.updated_at) }}</div>
                    </template>
                    <span v-else>--</span>
                </template>
            </template>
        </a-table>
    </a-card>
</template>

<script lang="ts" setup name="yichangAuditList">
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
import baseService from '@/utils/http/axios'

const router = useRouter()
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const format = 'YYYY-MM-DD HH:mm:ss'

const data = reactive({ loading: false })

const columns = [
    { title: '公司名称', dataIndex: 'name', width: '300px' },
    { title: '审核', dataIndex: 'verification', width: '240px' },
    { title: '审核类型', dataIndex: 'type', width: '180px' },
    { title: '代理商', dataIndex: 'seller', width: '140px' },
    { title: '申请审核人', dataIndex: 'submitName', width: '140px' },
    { title: '申请时间', dataIndex: 'created_at', width: '170px' },
    { title: '审核时间', dataIndex: 'updated_at', width: '200px' }
]

const createDefaultQuery = () => ({
    nameOrCode: '',
    status: [1] as number[],
    main_type: [] as number[],
    between_time: null as string | null,
    settle_address: ''
})

const queryParam = reactive<any>(createDefaultQuery())
const dataSource = ref<any[]>([])

const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '40', '50', '60', '200'],
    current: 1,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})

onMounted(() => loadData())

const loadData = () => {
    if (data.loading) return
    data.loading = true
    baseService({
        url: '/admin/v1/yichangAuditList',
        method: 'post',
        data: { page: pagination.current, limit: pagination.pageSize, ...queryParam }
    })
        .then((res) => {
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item: any) => ({
                ...item,
                desc: null,
                customer_id: item.id
            }))
        })
        .catch((res) => message.error(res.msg || '查询失败'))
        .finally(() => (data.loading = false))
}

const handleSearch = () => {
    pagination.current = 1
    loadData()
}

const refreshTable = () => {
    Object.assign(queryParam, createDefaultQuery())
    pagination.current = 1
    loadData()
}

const rangTime = computed(() => {
    if (!queryParam.between_time) return []
    return queryParam.between_time.split(',').map((item: string) => dayjs(item, format))
})

const rangTimeChange = (val: any, str: string[]) => {
    queryParam.between_time = val ? str.join(',') : null
}

const goCustomerClick = (name: string) => {
    router.push({ path: '/customer', query: { customer_name: name } })
}

const onChange = (val: any) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}

const verificatioChange = (record: any, type: number) => {
    baseService({
        url: '/admin/v1/yichangAuditApproval',
        method: 'post',
        data: { reason: record.desc, status: type, id: record.id }
    })
        .then(() => {
            message.success('操作成功')
            loadData()
        })
        .catch((res) => message.error(res.msg || '操作失败'))
}

const calculateTimeDifference = (start: string, end: string) => {
    if (!start || !end) return '--'
    const duration = dayjs(end).diff(dayjs(start), 'minute')
    const days = Math.floor(duration / (24 * 60))
    const hours = Math.floor((duration % (24 * 60)) / 60)
    const minutes = duration % 60
    return `${days > 0 ? days + '天' : ''}${hours > 0 ? hours + '小时' : ''}${minutes > 0 ? minutes : 1}分钟`
}
const formatExpireTime = (val: any) => {
    if (!val) return '--'
    // 兼容秒级时间戳（数字或纯数字字符串）
    const num = Number(val)
    if (!isNaN(num) && num > 0) {
        return dayjs.unix(num).format('YYYY-MM-DD')
    }
    // 兼容已是日期字符串的情况
    return dayjs(val).format('YYYY-MM-DD')
}
</script>

<style lang="less" scoped>
.table-page-search-submitButtons {
    display: inline-block;
    margin-bottom: 24px;
    white-space: nowrap;
}
</style>
